import { OrganizationInfos } from '@damofire/data-stas';
import { Query } from '@damofire/data-commons';

export interface SavedSearch extends OrganizationInfos {
  type?: 'issues';
  query?: Query;
  system?: boolean;
  name?: string;
  hidden?: boolean;
}
